/**
 * Created by az on 2017/8/9.
 */
import QbCollapse from './QbCollapse';

export default QbCollapse;
